const INIT_STATE = { data: [], error: null };
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case "GET_EVOLUTIONPLAN_EMPLOYEES_SUCCESS":
      return {
        ...state,
        data: { ...state.data, employees: action.payload },
        error: null,
      };
    case "GET_EVOLUTIONPLAN_EMPLOYEES_ERROR":
      return { ...state, data: [], error: action.payload };
    case "GET_EVOLUTIONPLAN_COMPLETION_RATIO_SUCCESS":
      return {
        ...state,
        data: { ...state.data, completionRatio: action.payload },
        error: null,
      };
    case "GET_EVOLUTIONPLANS_FOR_EMPLOYEE_SUCCESS":
      return {
        ...state,
        data: { ...state.data, evolutionPlans: action.payload },
        error: null,
      };
    case "GET_EVOLUTIONPLANS_FOR_EMPLOYEE_ERROR":
      return { ...state, data: [], error: action.payload };
    case "GET_EVOLUTIONPLANS_PREREQ_SUCCESS":
      return {
        ...state,
        data: { ...state.data, preRequisites: action.payload },
        error: null,
      };
    case "GET_EVOLUTIONPLANS_PREREQ_ERROR":
      return { ...state, data: [], error: action.payload };
    default:
      return state;
  }
};
